<template>
    <div>
        <button @click="stayModal" class="back-btn"><span class="arrow"><img src="@/assets/images/onboarding/leftArrow.svg"
                    alt="left-arrow"></span>
            back</button>
        <div class="title-wrapper">
            <h1 class="title">Payout Requirements</h1>
            <h4 class="subtitle">Provide necessary payout details</h4>
        </div>
        <div class="payout-form">
            <div>
                <div class="form-title">
                    <img src="@/assets/images/onboarding/bankIcon.svg" alt="bank-icon">
                    <h2 class="subtitle">Bank Details</h2>
                </div>

                <b-form>
                    <b-form-group id="input-group-2" label-for="locationName">
                        <template v-slot:label>
                            <p class="required-sign-payout">Merchant Name <span class="text-danger">*</span></p>
                        </template>
                        <b-form-input class="payout-input" :class="{ 'error-border': bankRequirementsFormErrors.name }"
                            id="input-2" v-model="form.merchantName" required></b-form-input>
                        <div v-if="bankRequirementsFormErrors.name" class="error-message">Merchant Name is required</div>
                    </b-form-group>
                    <b-form-group id="input-group-2" label-for="locationName">
                        <template v-slot:label>
                            <p class="required-sign-payout">Business Address <span class="text-danger">*</span></p>
                        </template>
                        <b-form-textarea class="payout-input"
                            :class="{ 'error-border': bankRequirementsFormErrors.address }" required id="textarea"
                            v-model="form.businessAddress" placeholder="" rows="3" max-rows="6"></b-form-textarea>
                        <div v-if="bankRequirementsFormErrors.address" class="error-message">Business Address is required
                        </div>
                    </b-form-group>
                    <b-form-group id="input-group-2" label-for="locationName">
                        <template v-slot:label>
                            <p class="required-sign-payout">Contact Number <span class="text-danger">*</span></p>
                        </template>
                        <b-input-group class="payout-input" prepend="+63">
                            <b-form-input @keydown="handleKeydown" v-model="form.contactNumber"
                                :class="{ 'error-border': bankRequirementsFormErrors.mobile_number || payoutRequirementsContactNumberInvalid }"
                                type="number" required></b-form-input>

                        </b-input-group>
                        <div v-if="bankRequirementsFormErrors.mobile_number" class="error-message">Mobile Number is
                            required</div>
                        <div v-if="payoutRequirementsContactNumberInvalid" class="error-message">Please enter a valid
                            contact number</div>
                    </b-form-group>
                    <b-form-group id="input-group-2" label-for="locationName">
                        <template v-slot:label>
                            <p class="required-sign-payout">Email Address <span class="text-danger">*</span></p>
                        </template>
                        <b-form-input class="payout-input" id="input-2" v-model="form.emailAddress"
                            :class="{ 'error-border': bankRequirementsFormErrors.email_address || bankValidEmail }"
                            required></b-form-input>
                        <div v-if="bankRequirementsFormErrors.email_address" class="error-message">Email Address is required
                        </div>
                        <div v-if="bankValidEmail" class="error-message">Please enter a valid email address
                        </div>
                    </b-form-group>
                    <b-form-group id="input-group-2" label-for="locationName">
                        <template v-slot:label>
                            <p class="required-sign-payout">TIN <span class="text-danger">*</span></p>
                        </template>
                        <b-form-input @keydown="handleKeydown" class="payout-input" id="input-2" v-model="form.tin_number"
                            :class="{ 'error-border': bankRequirementsFormErrors.tin_number || minimumNumberError }"
                            required></b-form-input>
                        <div v-if="bankRequirementsFormErrors.tin_number" class="error-message">Tin is required</div>
                        <div v-if="minimumNumberError" class="error-message">Please enter a valid TIN</div>
                    </b-form-group>
                    <b-form-group id="input-group-2" label-for="locationName">
                        <template v-slot:label>
                            <p class="required-sign-payout">Currency <span class="text-danger">*</span></p>
                        </template>
                        <b-form-select disabled v-model="selectedCurrency" :options="optionsCurrency" class="payout-input"
                            type="text" id="input-2"
                            :class="{ 'error-border': bankRequirementsFormErrors.bank_account_currency }"
                            required></b-form-select>
                        <div v-if="bankRequirementsFormErrors.bank_account_currency" class="error-message">Currency is
                            required</div>
                    </b-form-group>
                    <b-form-group id="input-group-2" label-for="locationName">
                        <template v-slot:label>
                            <p class="required-sign-payout">Bank Name<span class="text-danger">*</span></p>
                        </template>
                        <b-form-input class="payout-input" id="input-2" v-model="form.bankName" required
                            :class="{ 'error-border': bankRequirementsFormErrors.bank_name }"></b-form-input>
                        <div v-if="bankRequirementsFormErrors.bank_name" class="error-message">Bank Name is required
                        </div>
                    </b-form-group>
                    <b-form-group id="input-group-2" label-for="locationName">
                        <template v-slot:label>
                            <p class="required-sign-payout">Bank Address <span class="text-danger">*</span></p>
                        </template>
                        <b-form-textarea class="payout-input" required id="textarea" v-model="form.bankAddress"
                            :class="{ 'error-border': bankRequirementsFormErrors.bank_address }"
                            placeholder="Enter something..." rows="3" max-rows="6"></b-form-textarea>
                        <div v-if="bankRequirementsFormErrors.bank_address" class="error-message">Bank Address is required
                        </div>
                    </b-form-group>
                    <b-form-group id="input-group-2" label-for="locationName">
                        <template v-slot:label>
                            <p class="required-sign-payout">Account Name <span class="text-danger">*</span></p>
                        </template>
                        <b-form-input class="payout-input" id="input-2" v-model="form.accountName" required
                            :class="{ 'error-border': bankRequirementsFormErrors.bank_account_name }"></b-form-input>
                        <div v-if="bankRequirementsFormErrors.bank_account_name" class="error-message">Account Name is
                            required</div>
                    </b-form-group>
                    <b-form-group id="input-group-2" label-for="locationName">
                        <template v-slot:label>
                            <p class="required-sign-payout">Account Number <span class="text-danger">*</span></p>
                        </template>
                        <b-form-input @keydown="handleKeydown" class="payout-input" id="input-2" type="number"
                            v-model="form.accountNumber"
                            :class="{ 'error-border': bankRequirementsFormErrors.bank_account_number || minimumAccountNumberError }"
                            required></b-form-input>
                        <div v-if="bankRequirementsFormErrors.bank_account_number" class="error-message">Account Number is
                            required</div>
                        <div v-if="minimumAccountNumberError" class="error-message">Please enter a valid bank account
                            number.</div>
                    </b-form-group>
                    <b-form-group id="input-group-2" label-for="locationName">
                        <template v-slot:label>
                            <p class="required-sign-payout">Bank Swift Code <span class="text-danger">*</span></p>
                        </template>
                        <b-form-input class="payout-input" id="input-2" v-model="form.bankSwiftCode"
                            :class="{ 'error-border': bankRequirementsFormErrors.bank_swift_code }" required></b-form-input>
                        <div v-if="bankRequirementsFormErrors.bank_swift_code" class="error-message">Bank Swift Code is
                            required</div>
                    </b-form-group>

                </b-form>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState, mapActions, mapGetters } from "vuex";
export default {
    data() {
        return {
            form: {
                merchantName: '',
                businessAddress: '',
                contactNumber: '',
                emailAddress: '',
                tin_number: '',
                currency: "PHP",
                bankName: '',
                bankAddress: '',
                accountName: '',
                accountNumber: '',
                bankSwiftCode: ''
            },
            selectedCurrency: 'PHP',
            optionsCurrency: [
                { value: 'PHP', text: 'PHP' }
            ]
        }
    },
    computed: {
        ...mapState("onboarding", {
            bankDetails: state => state.bankDetails,
            bankRequirementsFormErrors: state => state.bankRequirementsFormErrors,
            bankValidEmail: state => state.bankValidEmail,
            minimumNumberError: state => state.minimumNumberError,
            minimumAccountNumberError: state => state.minimumAccountNumberError,
            payoutRequirementsContactNumberInvalid: state => state.payoutRequirementsContactNumberInvalid
        }),
    },
    methods: {
        bankDetailsWatcher() {
            this.$watch(
                () => this.bankDetails,
                (newValue, oldValue) => {
                    if (newValue) {
                        this.loadBankDetails();
                    }

                },
                { immediate: true }
            )
        },

        loadBankDetails() {
            this.form.merchantName = this.bankDetails.name
            this.form.businessAddress = this.bankDetails.address
            this.form.contactNumber = this.bankDetails.mobile_number
            this.form.emailAddress = this.bankDetails.email_address
            this.form.tin_number = this.bankDetails.tin_number
            this.form.currency = this.selectedCurrency
            this.form.bankName = this.bankDetails.bank_name
            this.form.bankAddress = this.bankDetails.bank_address
            this.form.accountName = this.bankDetails.bank_account_name
            this.form.accountNumber = this.bankDetails.bank_account_number
            this.form.bankSwiftCode = this.bankDetails.bank_swift_code
            console.log(this.bankDetails.tin_number)
        },
        stayModal() {
            this.$router.go(-1);
        },
        handleKeydown(event) {
            // Allow only numeric characters and certain key codes
            if (
                !/^[0-9]*$/.test(event.key) && // Numeric characters
                event.keyCode !== 8 && // Backspace
                event.keyCode !== 46 && // Delete
                event.keyCode !== 37 && // Left arrow
                event.keyCode !== 39 // Right arrow
            ) {
                event.preventDefault();
            }
        }
    },
    mounted() {
        this.bankDetailsWatcher()
    },
    watch: {
        form: {
            handler(newValue, oldValue) {
                this.$store.commit('onboarding/setFormBankDetails', newValue);
            },
            deep: true
        }
    }

}
</script>

<style lang="scss" scoped>
.no-underline {
    text-decoration: none;
}

.form-title {
    display: flex;
    align-items: center;
    border-bottom: 1px solid #E9EBED;
    padding: 8px 0px;
    margin-top: 27px;
    margin-bottom: 25px;

    .subtitle {
        color: #2F3941;
        font-family: MainFontRegular, sans-serif;
        font-size: 16px;
        font-style: normal;
        line-height: normal;
        margin-bottom: 0px;
        margin-left: 8px;

    }
}

.back-btn {
    display: flex;
    align-items: center;
    color: #2F3941;
    font-family: MainFontRegular, sans-serif;
    font-size: 14px;
    font-style: normal;
    line-height: normal;
    height: 33px;
    padding: 6px 17px 6px 12px;
    border-radius: 40px;
    border: 1px solid #E9EBED;
    background: #FFF;
    box-shadow: 0px 2px 5px -3px rgba(67, 67, 67, 0.25);
    margin-bottom: 24px;

    &:hover {
        text-decoration: none;
    }

    .arrow {
        margin-right: 5px;
    }
}

.title-wrapper {
    margin-bottom: 15px;

    .title {
        color: #2F3941;
        font-family: MainFontRegular, sans-serif;
        font-size: 20px;
        font-style: normal;
        line-height: normal;
    }

    .subtitle {
        color: #68737D;
        font-family: MainFontRegular, sans-serif;
        font-size: 14px;
        font-style: normal;
        line-height: normal;
    }
}

.payout-form {
    display: flex;
    justify-content: center;
    border-radius: 10px;
    border: 1px solid #E9EBED;
    background: #FFF;
    box-shadow: 0px 2px 5px -3px rgba(67, 67, 67, 0.25);
    width: 576px;
    flex-wrap: wrap;

    @media (max-width: 1328px) {
        width: auto;
        padding: 0px 20px
    }

    .payout-input {
        width: 519px;
        border-radius: 6px;

        @media (max-width: 1328px) {
            width: 400px
        }

        @media (max-width: 1102px) {
            width: 600px;
        }

        @media (max-width: 672px) {
            width: 100%;
        }
    }

    .error-border {
        border: solid 2px red;
    }

    .error-message {
        color: red;
        font-size: 12px;
        margin-top: 5px;
    }


    .required-sign-payout {
        color: #2F3941;
        font-family: MainFontRegular, sans-serif;
        font-size: 13px;
        font-style: normal;
        line-height: normal;
        margin-bottom: 8px;
        display: flex;
        justify-items: center;

        span {
            margin-top: 3px;
            margin-left: 5px;
        }
    }

}
</style>